export default __webpack_public_path__ + "static/media/atena-solutions-negative.2ef9a340.svg";